import { useNavigate } from "react-router";
import {type ReactNode, useEffect} from "react";
import {StaffType, useStaffGuard} from "../hooks/useStaffGuard.ts";

export const StaffGuard = ({ staffTypes, children }: { staffTypes?: Array<StaffType>, children: ReactNode }) => {
    const { isStaff, isLoading, role } = useStaffGuard();
    const navigate = useNavigate();

    useEffect(() => {
        console.log("IsStaff: " + isStaff)
        console.log("staffTypes: " + staffTypes);
        console.log("includes: " + (staffTypes && staffTypes.includes(role)))
        console.log("role: " + role);
        if (!isLoading && (!isStaff || (staffTypes && !staffTypes.includes(role)))) {
            navigate("/");
        }
    }, [isLoading, isStaff, role, navigate]);

    if (isLoading) {
        return <div>...</div>;
    }

    return <>{children}</>;
};
